import { render, staticRenderFns } from "./ViewNewOrders.vue?vue&type=template&id=6170fb6b"
import script from "./ViewNewOrders.vue?vue&type=script&lang=js"
export * from "./ViewNewOrders.vue?vue&type=script&lang=js"
import style0 from "./ViewNewOrders.vue?vue&type=style&index=0&id=6170fb6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports